/**
 * vmx-sticky-cta.js
 * Mobile-only sticky "Add to bag" bar.
 *
 * - Hides on screens >= 768px (via IntersectionObserver + CSS media query guard).
 * - Uses IntersectionObserver on the in-page CTA anchor (#vmx-pdp-cta-anchor).
 * - When the anchor scrolls above the fold (out of view from top), slide up the bar.
 * - No innerHTML mutations.
 */

function initStickyCta() {
  const bar    = document.querySelector('[data-sticky-cta]');
  if (!bar) return;

  const anchorId = bar.dataset.observe || 'vmx-pdp-cta-anchor';
  const anchor   = document.getElementById(anchorId);
  if (!anchor) return;

  // Shows on all sizes: mobile = bottom bar; desktop = Bloom-style forest bar
  // pinned below the sticky header (positioned purely in CSS).
  const show = () => {
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
    bar.removeAttribute('inert');
  };

  const hide = () => {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    bar.setAttribute('inert', '');
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      // Show bar only when the buy-box has scrolled above viewport top
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        show();
      } else {
        hide();
      }
    },
    { threshold: 0, rootMargin: '0px 0px -100% 0px' },
  );

  observer.observe(anchor);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyCta);
} else {
  initStickyCta();
}
